import { Component, Input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'wl-partial-accordion-title',
  templateUrl: './partial-accordion-title.component.html',
  styleUrls: ['./partial-accordion-title.component.scss'],
  standalone: true,
  imports: [FaIconComponent],
})
export class PartialAccordionTitleComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() icon?: IconProp;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() after?: string;
}
